module.exports = __webpack_public_path__ + "img/9791165507978.9614ff4a.jpg";